import { useTranslation } from 'react-i18next'

import { ArcadeFieldLabel, FieldLabel, PaddingInset, Text } from '@cash-design-system/react'
import { useArcadeMigrationFeatureFlag } from '@cash-web/shared-data-access-arcade-migration'
import { regex } from '@cash-web/shared-util-validation'

import { FormInput } from '../FormInput'

type NameInputProps = {
  helpText?: string
  name: string
  autoFocus?: boolean
  defaultValue?: string
  label?: string
}

export function NameInput({ name, defaultValue, autoFocus, label, helpText }: NameInputProps) {
  const { t } = useTranslation()
  const isArcadeMigrationEnabled = useArcadeMigrationFeatureFlag('apps')

  const formLabel = label ? label : t('Full name', { context: 'label' })

  if (isArcadeMigrationEnabled) {
    return (
      <ArcadeFieldLabel label={formLabel}>
        <FormInput
          aria-label={formLabel}
          placeholder={t('First and last name', { context: 'placeholder' })}
          defaultValue={defaultValue}
          spellCheck={false}
          name={name}
          autoFocus={autoFocus}
          helpText={helpText}
          rules={{
            required: {
              value: true,
              message: t('Enter your full name.', { context: 'error message' }),
            },
            pattern: {
              value: regex.fullName,
              message: t('Name is invalid.', { context: 'error message' }),
            },
          }}
        />
      </ArcadeFieldLabel>
    )
  }

  return (
    <FieldLabel label={formLabel}>
      <FormInput
        aria-label={formLabel}
        placeholder={t('First and last name', { context: 'placeholder' })}
        defaultValue={defaultValue}
        spellCheck={false}
        name={name}
        autoFocus={autoFocus}
        rules={{
          required: {
            value: true,
            message: t('Enter your full name.', { context: 'error message' }),
          },
          pattern: {
            value: regex.fullName,
            message: t('Name is invalid.', { context: 'error message' }),
          },
        }}
      />
      {helpText ? (
        <PaddingInset>
          <Text typography="helpText" color="textSubtle">
            {helpText}
          </Text>
        </PaddingInset>
      ) : null}
    </FieldLabel>
  )
}
